module.exports = __webpack_public_path__ + "img/icon-md-mood-04.71e88691.svg";